<nb-select fullWidth
           [(selected)]="value"
           [disabled]="isDisabled">
  <nb-option *ngIf="showEmptyOption" [value]="null">Alle</nb-option>
  <nb-option *ngFor="let option of BuildingClass"
             [value]="option">{{ option | buildingClassTranslation }}</nb-option>
</nb-select>
